import BaseListPresenter from "../../../../base/BaseListPresenter";
import { dialog } from "../../../../nq-component";
import { exportToZip } from "../../../../pdfZipExporter";
import InterviewFormPDF from "../../../../components/bulkPrint/interviewForm";
import ExitInterviewPDF from "../../../../components/ExitInterviewPDF";
import ConsentPrintPDF from "../../../../components/bulkPrint/ConsentPrintPDF";
import OrientationForm from "../../../../components/bulkPrint/orientation-form/OrientationForm";

class MyWalkInApplicantListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    this.limit = 20;
    this.where = {
      recruiter: {
        id: user.id,
      },
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickView(empDetails) {
    this.view.navigateTo(`/me/recruiter/re-process/form/${empDetails?.id}`);
  }

  onChangePosition(value, schema) {
    this.reset();
    this.filter = {
      positionApplied: { $regex: value, $options: "i" },
    };
    this.getObjects();
  }

  onChangeReference(value, schema) {
    console.log("VV", value);
    this.reset();
    this.filter = {
      referenceNumber: { $regex: value, $options: "i" },
    };
    this.getObjects();
  }

  //   onChangePosition(value, schema) {
  //     this.reset();

  //     const excludedFields = [
  //       "id",
  //       "created",
  //       "updated",
  //       "acl",
  //       "status",
  //       "applicant",
  //       "recruiter",
  //       "coordinator",
  //     ];

  //     this.filter = {
  //       $or: Object.keys(schema.fields)
  //         .filter(
  //           (field) =>
  //             !excludedFields.includes(field) &&
  //             schema.fields[field].type === "String"
  //         )
  //         .map((field) => ({
  //           [field]: { $regex: value, $options: "i" },
  //         })),
  //     };

  //     this.getObjects();
  //   }

  async bulkExport() {
    const { selected } = this.view.state;
    const today = new Date();
    const month = today.getMonth() + 1;
    const day = today.getDay();
    const year = today.getFullYear();

    const filesToDownload = [
      "cv",
      "diploma",
      "tor",
      "reportCard",
      "graduationCertificate",
      "coe",
      "trainingCertificate",
      "medical",
      "mayorPermit",
      "healthPermit",
      "nbi",
      "policeClearance",
    ];

    const components = [
      {
        component: InterviewFormPDF,
        fileName: "Interview_Form",
        options: { mode: "auto" },
      },
      {
        component: ConsentPrintPDF,
        fileName: "Consent_Form",
        options: { mode: "manual" },
      },
      // {
      //   component: OrientationForm,
      //   fileName: "Orientation_Form",
      //   options: { mode: "manual", pageCount: 3 },
      // },
    ];

    try {
      // this.view.progressModal();

      this.view.setState({ generating: true, generateProgress: 0 });
      await exportToZip(
        selected,
        components,
        filesToDownload,
        `LGS_Documents-${month}/${day}/${year}`,
        (percent, current, total) => {
          this.view.setState({
            generateProgress: percent,
            currentGenerated: current,
            totalGenerate: total,
          });
          console.log(`Candidate ${current}/${total} (${percent}%) processed`);
        }
      );

      dialog.close();
      this.view.setState({ generating: false });
    } catch (error) {
      this.view.setState({ generating: false });
      console.error("Bulk Export error: ", error);
    }
  }
}

export default MyWalkInApplicantListPresenter;
